import React, { useEffect, useState } from "react";
import FadeIn from "react-fade-in/lib/FadeIn";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Form,
  FormGroup,
  Label,
  Row,
  Table,
} from "reactstrap";

import Breadcrumb from "../../../../components/Common/Breadcrumb";
import SubMenuLeave from "../../SubMenuLeaveOnline";
import NewThaiDatePicker from "../../../../components/Common/NewThaiDatePicker";
import { GetCookieData, GetCookieToken } from "../../../Cookie/GetCookie";
import axios from "axios";
import { ConvertDate } from "../../../Function/ConvertDate";

const Menu3 = () => {
  const baseURL = process.env.REACT_APP_API_CORS;
  const token = GetCookieToken("userToken");
  const user = GetCookieData("userData");
  const user_id = user?.user_id;
  const [data, setData] = useState([])
  const [searchData, setSearchData] = useState({
    startDate : null,
    toDate : new Date(new Date().setHours(0,0,0,0))
  })
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
  }, [])

  const getLeaveDayCollect = () => {
    
  }

  const setSearchToDate = (e) => {
    setSearchData((prev) => ({
      ...prev,
      date: e,
    }));
  }
  
  return (
    <FadeIn>
      <SubMenuLeave menu={3} />
      <Breadcrumb
        title="หน้าหลัก"
        breadcrumbItem="การลาออนไลน์"
        isBack={true}
        isSubMenu={true}
        subMenuName="คำนวณวันลาสะสม"
        path="/leave"
      />
      <Row className="mt-3 d-flex justify-content-center">
        <Col xxl={9}>
          <Card>
            <CardBody className="">
              <CardTitle>คำนวณวันลาสะสม</CardTitle>
              <Form onSubmit={(e) => {
                e.preventDefault()
                
              }}>
                <FormGroup row>
                  <Label className="text-end" xxl={2}>
                    คำนวณถึงวันที่
                  </Label>
                  <Col xxl={2}>
                  {/* <Flatpickr
                      className="form-control d-block"
                      placeholder="วัน/เดือน/ปี"
                      value={searchData?.date}
                      options={{
                        // altInput: true,
                        dateFormat: "d-m-Y",
                        ariaDateFormat: "F j, Y",
                        locale: "th",
                      }}
                      onChange={(e) => {
                        setSearchData((prev) => ({
                          ...prev,
                          date: e[0],
                        }));
                      }}
                    /> */}
                    <NewThaiDatePicker name={"search_to_date"} value={searchData?.date} setValue={setSearchToDate} minDate={data?.leave_from_date} returnType = {"DateTime"} placeholderText = "วัน/เดือน/ปี" />
                  </Col>
                  <Col xxl={3}>
                    <Button type="submit" color="info">
                      <i className="fas fa-search me-2"></i>คำนวณวันลาสะสม
                    </Button>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label className="ms-4 text-danger" xxl={6}>กรุณาระบุวันที่ไม่เกินวันสุดท้ายของปีงบประมาณที่ต้องการคำนวณวันลาสะสม</Label>
                </FormGroup>
              </Form>
              <Row className="d-flex justify-content-center">
                <Col>
                <Table>
                  <thead className="text-center">
                    <tr>
                      <th>ลำดับ</th>
                      <th className="w-75">ชื่อ-นามสกุล</th>
                      <th>คำนวณวันลาสะสม</th>
                    </tr>
                  </thead>
                  {data?.length === 0 ? (
                    <tbody>
                    <tr>
                    <td colSpan="3" className="text-center fs-6">
                      ไม่มีข้อมูล
                    </td>
                    </tr>
                    </tbody>
                  ) : data?.map((item,idx) => {
                    <tr>
                      <td>{idx + 1}</td>
                      <td></td>
                      <td></td>
                    </tr>
                    })
                  }
                  <div>

                  </div>
                </Table>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </FadeIn>
  );
};

export default Menu3;
